module.exports = __webpack_public_path__ + "static/media/icon_salida_emergencia.e654be84.svg";